import { logEvent } from "firebase/analytics";
import { analytics } from "./config";

// Universal tracking function - use this for all analytics events
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
    console.log(`📊 Analytics Event: ${eventName}`, parameters);
  }
};
